import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./Home.css";

import homeImage1 from "../assets/images/home1.svg";
import homeImage2 from "../assets/images/home2.svg";
import logo from "../assets/images/logo.svg";
import IntroImage1 from "../assets/images/intro-1.svg";
import IntroImage2 from "../assets/images/intro-2.svg";
import IntroImage3 from "../assets/images/intro-3.svg";
import IntroImage4 from "../assets/images/intro-4.svg";
import IntroImage5 from "../assets/images/intro-5.svg";
import IntroImage6 from "../assets/images/intro-6.svg";
import IntroImage7 from "../assets/images/intro-7.svg";
import IntroImage8 from "../assets/images/intro-8.svg";
import IntroImage9 from "../assets/images/intro-9.svg";
import IntroImage10 from "../assets/images/intro-10.svg";
import LogoBlur from "../assets/images/logo-blur.svg";
import CPUImage from "../assets/images/cpu.svg";
import GPUImage from "../assets/images/gpu.svg";
import GenerativeImage from "../assets/images/generative.svg";
import { AiFillCheckCircle } from "react-icons/ai";
import Footer from "../components/Footer";


export default function Home() {
    const [showChatBot, setShowChatBot] = useState(true);

    const handleChatBotToggle = () => {
        setShowChatBot(prevState => !prevState);
    }

    const scrollToPlans = () => {
        const targetElement = document.querySelector('#plans');
        targetElement.scrollIntoView({ behavior: 'smooth' });
    };

    const plans = [
        {
            title: 'پلن پایه',
            price: '557 هزار تومان ماهانه',
            features: [
                '۳ هزار پاسخ',
                'داشبورد اطلاعاتی',
                'فعال‌سازی ۱۰ اپراتور',
                'ویجت باطراحی اختصاصی برای سایت شما'
            ]
        },
        {
            title: 'پلن استاندارد',
            price: '۱ میلیون و ۴۱۴ هزار تومان ماهانه',
            features: [
                '۱۰ هزار پاسخ',
                'داشبود اطلاعاتی',
                'فعال‌سازی ۴۰ اپراتور',
                'ویجت باطراحی اختصاصی برای سایت شما',
                'فعال‌سازی بات تلگرام هوشمند',
                'امکان اتصال در لحظه به اپراتور'
            ]
        },

        {
            title: 'پلن پیشرفته',
            price: '۳ میلیون و ۶۴۳ هزار تومان ماهانه',
            features: [
                '۳۰ هزار پاسخ',
                'داشبود اطلاعاتی',
                'فعال‌سازی ۷۰ اپراتور',
                'ویجت باطراحی اختصاصی برای سایت شما',
                'فعال‌سازی بات تلگرام هوشمند',
                'پشتیبانی از پیام‌های صوتی',
                'امکان اتصال در لحظه به اپراتور'
            ]
        },

        {
            title: 'پلن سازمانی',
            price: 'تماس بگیرید',
            features: [
                'نامحدود پاسخ',
                'داشبود اطلاعاتی',
                'نامحدود اپراتور',
                'ویجت باطراحی اختصاصی برای سایت شما',
                'فعال‌سازی بات تلگرام هوشمند',
                'پشتیبانی از پیام‌های صوتی',
                'امکان اتصال در لحظه به اپراتور',
                'تیم فنی و پشتیبانی اختصاصی',
            ]
        }
    ];

    const Plans = () => {
        return (
            <div className="plan-container">
                <h2 className="text-center text-primary fw-bold">چت‌یار با توجه به نیاز سازمانی شما پلن‌های مختلفی ارائه می‌کند.</h2>
                <div className="row justify-content-center mt-4">
                    {plans.map((plan, index) => (
                        <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <div className="card plan-card text-center p-3 h-100">
                                <h3 className="fw-bold mt-3">{plan.title}</h3>
                                <p className="fs-5 fw-bold text-nowrap mt-2">{plan.price}</p>
                                <div className="card-body">
                                    {plan.features.map((feature, i) => (
                                        <div key={i} className="d-flex align-items-center justify-content-start my-2">
                                            <AiFillCheckCircle className="plan-tick" />
                                            <span className="text-end">{feature}</span>
                                        </div>
                                    ))}
                                </div>
                                <button className="btn btn-primary w-100 mt-3">
                                    {plan.price === 'تماس بگیرید' ? <a href="tel:09915381238" className="text-white text-decoration-none">تماس بگیرید</a> : 'ثبت سفارش'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="">
            <div className="row mx-0" id="home">
                <div className="col-lg-6 col-md-6 col-sm-12 items-center my-auto">
                    <div className="lg:px-24 my-16 lg:my-auto">
                        <p className="text-nowrap fs-5" style={{ color: '#0156F9' }}>
                            همکار بخش پشتیبانی
                        </p>
                        <img
                            src={require('../assets/images/text1.png')}
                            alt="text1"
                            className="my-4"
                        />
                        <p className="text-lg">
                            چت‌یار یک دستیار مکالمه مبتنی بر هوش مصنوعی است که برای پاسخگویی به مشتریان و کاهش هزینه‌های
                            سازمان، طراحی و توسعه یافته است.
                        </p>
                        <p className="text-lg">
                            سازمان خود را با پشتیبانی دقیق، کارآمد و مشتری محور توانمند کنید، اطمینان حاصل کنید که هر
                            پرسشی
                            با پاسخ درست مواجه می شود. خدمات مشتریان خود را امروز با "چت‌یار" ارتقا دهید.
                        </p>
                        <div className="flex gap-4">
                            <div className="btn text-nowrap rounded-1"
                                onClick={() => window.open('https://auth.chatyar.ir/signup', '_blank')}
                                style={{ borderColor: '#0156F9', color: '#0156F9', width: '140px' }}>
                                رایگان شروع کن
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 me-0 px-3 my-5">
                    <video className="w-100 rounded-4" controls>
                        <source src={require('../assets/videos/Intro.mp4')} type="video/mp4" />
                    </video>
                </div>
            </div>

            <Plans />

            <div className="lg:relative home-1 w-100 lg:my-10" id="about_us">
                <img
                    src={homeImage2}
                    alt="home2"
                    className="lg:absolute z-10 right-10 home-1-image"
                />
                <img
                    src={logo}
                    alt="logo"
                    id="logo"
                    className="lg:absolute  z-20 h-auto right-0 home-1-logo"
                />
                <div className="card home-card-1 text-wrap text-truncate">
                    <div className="card-body flex">
                        <div>
                            <p className="text-nowrap fs-4 fw-bolder" style={{ color: '#0156F9' }}>
                                معرفی محصول
                            </p>
                            <p className="leading-loose">
                                چت‌یار، محصول شرکت دادماتک، با بهره‌گیری از هوش مصنوعی پیشرفته، گفت‌وگوهای مؤثر و
                                بی‌وقفه‌ای با مشتریان شما برقرار می‌کند و به صورت ۲۴ ساعته و ۷ روز هفته به نیازهای آن‌ها
                                پاسخ می‌دهد.
                            </p>
                            <p className="leading-loose">
                                چت‌یار با استفاده از الگوریتم‌های پیشرفته هوش مصنوعی، نه تنها قادر است به‌طور همزمان به
                                هزاران نفر پاسخ دهد، بلکه با درک گفت‌وگوهای محاوره‌ای و اصلاح غلط‌های املایی، تجربه
                                پشتیبانی بی‌نظیری را برای مشتریان فراهم می‌کند. این چت‌بات هوشمند می‌تواند در هزینه‌های
                                ثابت و متغیر سازمان صرفه‌جویی کرده و بدون نیاز به سرمایه‌گذاری‌های قابل‌توجه در منابع
                                انسانی و زیرساخت‌های سنتی، خدماتی کارآمد و مؤثر ارائه دهد.
                            </p>
                            <p className="leading-loose">
                                استفاده از چت‌یار به عنوان یک ابزار نوآورانه، می‌تواند محدودیت‌های روش‌های سنتی ارتباطی
                                مانند تماس تلفنی، سیستم تیکتینگ، ایمیل و مراجعه حضوری را پشت سر بگذارد و به سازمان‌ها
                                کمک کند تا با مشتریان خود ارتباطی پایدار و مؤثر برقرار کنند.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-center justify-center items-center mb-5" id="services">
                <p className="fs-4 fw-bold" style={{ color: '#0156F9' }}>معرفی محصول</p>
                <p className="lg:w-1/2 mx-auto fs-6 text-gray-500">
                    استفاده از چت‌یار به عنوان یک ابزار نوآورانه، می‌تواند محدودیت‌های روش‌های سنتی ارتباطی مانند تماس
                    تلفنی، سیستم تیکتینگ، ایمیل و مراجعه حضوری را پشت سر بگذارد و به سازمان‌ها کمک کند تا با مشتریان خود
                    ارتباطی پایدار و مؤثر برقرار کنند.
                </p>
            </div>
            <div className="row justify-center mx-0">
                <div className="col-auto">
                    <img
                        src={IntroImage1}
                        alt="intro1"
                        className=""
                    />
                    <img
                        src={IntroImage3}
                        alt="intro3"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage5}
                        alt="intro5"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage7}
                        alt="intro7"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage9}
                        alt="intro9"
                        className="mt-4"
                    />
                </div>
                <div className="col-auto">
                    <img
                        src={IntroImage2}
                        alt="intro2"
                        className=""
                    />
                    <img
                        src={IntroImage4}
                        alt="intro4"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage6}
                        alt="intro6"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage8}
                        alt="intro8"
                        className="mt-4"
                    />
                    <img
                        src={IntroImage10}
                        alt="intro10"
                        className="mt-4"
                    />
                </div>
            </div>
            <div className="relative card home-card-2 mb-5">
                <img
                    src={LogoBlur}
                    alt="logo-blur"
                    className="absolute z-10 top-10"
                />
                <div className="card-body grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-4 items-center px-8">
                    <div className="">
                        <p className="lg:text-nowrap md:text-nowrap sm:text-wrap fs-4 fw-bolder"
                            style={{ color: '#0156F9' }}>
                            چت‌یار در نسخه‌های مختلفی قابل ارائه می‌باشد
                        </p>
                        <p className="leading-loose">
                            چت‌یار در سه نسخه متفاوت ارائه می‌شود که هر یک برای نیازها و حجم کاری مختلف طراحی شده‌اند.
                            این نسخه‌ها شامل نسخه CPU برای سازمان‌های کوچک تا متوسط، نسخه GPU برای سازمان‌های بزرگ‌تر با
                            نیاز به پردازش سریع‌تر، و نسخه مولد برای ارائه محتوای دقیق‌تر و هوشمندتر می‌باشند. با انتخاب
                            نسخه مناسب، سازمان‌ها می‌توانند به طور مؤثر و کارآمد با مشتریان خود ارتباط برقرار کنند.
                        </p>
                    </div>
                    <div className="">
                        <div className="flex my-4 lg:px-5 sm:px-0">
                            <img
                                src={CPUImage}
                                alt="cpu"
                                className="mx-3"
                            />
                            <div className="">
                                <p className="text-nowrap fs-4 fw-bolder my-auto">نسخه CPU</p>
                                <p className="text-sm leading-loose my-auto">
                                    مناسب برای کاربردهای عمومی و سازمان‌های کوچک تا متوسط می‌باشد که نیاز به پاسخگویی
                                    سریع و کارآمد به سوالات مشتریان دارند.
                                </p>
                            </div>
                        </div>
                        <div className="flex my-4 lg:px-5 sm:px-0">
                            <img
                                src={GPUImage}
                                alt="gpu"
                                className="mx-3"
                            />
                            <div className="">
                                <p className="text-nowrap fs-4 fw-bolder my-auto">نسخه GPU</p>
                                <p className="text-sm leading-loose my-auto">
                                    برای سازمان‌های بزرگ‌تر و کاربردهایی که نیاز به پردازش سریع‌تر و پاسخگویی همزمان به
                                    تعداد بیشتری از مشتریان دارند، مناسب است.
                                </p>
                            </div>
                        </div>
                        <div className="flex my-4 lg:px-5 sm:px-0">
                            <img
                                src={GenerativeImage}
                                alt="cpu"
                                className="mx-3"
                            />
                            <div className="">
                                <p className="text-nowrap fs-4 fw-bolder my-auto">نسخه مولد</p>
                                <p className="text-sm leading-loose my-auto">
                                    چت‌یار نسخه مولد با استفاده از فناوری‌های پیشرفته‌تر، امکان تولید محتوای دقیق‌تر و
                                    هوشمندتر را فراهم می‌کند و برای سازمان‌هایی که به دنبال تجربه ارتباطی برتر با
                                    مشتریان خود هستند، ایده‌آل است.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
